/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Privacy_InfocardInputs */

const es_tyc_privacy_infocard = /** @type {(inputs: Tyc_Privacy_InfocardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata no es responsable de las practicas de privacidad o el manejo de datos de Fuentes Conectadas.`)
};

const en_tyc_privacy_infocard = /** @type {(inputs: Tyc_Privacy_InfocardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata is not responsible for the privacy practices or data handling of Connected Sources.`)
};

/**
* | output |
* | --- |
* | "Nexata is not responsible for the privacy practices or data handling of Connected Sources." |
*
* @param {Tyc_Privacy_InfocardInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_privacy_infocard = /** @type {((inputs?: Tyc_Privacy_InfocardInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Privacy_InfocardInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_privacy_infocard(inputs)
	return en_tyc_privacy_infocard(inputs)
});
export { tyc_privacy_infocard as "tyc.privacy.infocard" }